module.exports = __webpack_public_path__ + "img/footterLogo.2411ede5.png";